module.exports = "/assets/data/44106943e0b68b2844d0bfbe02038023-SN12.data.json";